// extracted by mini-css-extract-plugin
module.exports = {"abbr":"abbr-317xli198d"};